<template>
	<div class="game" :class="{ shake: shake.color, editing }" :style="{ 'animation-delay': shake.delay + 's' }">
		
		<side position="top" :character="fight.opponent" />
		<side position="bottom" :character="fight.player" :editing="editing" @toggle="toggle_deck" />

		<div v-if="fight.status === 'ready'" class="game-button" :class="{ inactive: fight.player.cards.length !== fight.player.nb_slots }" v-hammer:tap="() => start_fight()">Fight!</div>
		
		<transition name="rewards" appear>
			<rewards v-if="fight.status === 'ended' && fight.rewards" :editing="editing" @toggle="toggle_deck" />
		</transition>
		
		<deck :editing="editing" @toggle="toggle_deck" />
		<div class="game-infos">
			<div class="wins">Fight {{ game.wins.length + 1 }}/17</div>
		</div>
		<div class="score">
			<div class="label">Score</div>
			<div class="no"><span>{{ score }}</span></div>
		</div>

		<div class="cog" v-hammer:tap="() => show_settings()"></div>
		
		<transition name="settings">
			<settings v-if="app.settings" />
		</transition>
		
		<transition name="tuto">
			<tuto v-if="app.config.tuto" @close="close_tuto" />
		</transition>

		<transition name="next-opponent">
			<next-opponent v-if="game.status === 'ended' || game.status === 'starting' || fight.status === 'next-opponent' /*&& game.wins.length > 0*/" />
		</transition>

		
		<div class="shake-color" :class="shake.color" :style="{ 'animation-delay': shake.delay + 's' }"></div>
		<div v-show="fight.status === 'fighting'" class="prevent-over"></div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Side from '@/components/game/side'
import Deck from '@/components/game/deck'
import NextOpponent from '@/components/game/next-opponent'
import Rewards from '@/components/game/rewards'
import Tuto from '@/components/game/tuto'
import Settings from '@/components/game/settings'
import Sounds from '@/js/sounds'

export default {
	name: 'game',
	data() {
		return {
			editing: false
		}
	},
	computed: {
		...mapGetters([ 'app', 'game', 'fight', 'level', 'score' ]),
		shake() {
			if (this.app.shake) {
				return { color: this.app.shake.color, delay: this.app.shake.delay }
			}
			return { color: '', delay: 0 }
		}
	},
	methods: {
		toggle_deck() {
			Sounds.play('button')
			this.editing = !this.editing
		},
		start_fight() {
			if (this.fight.player.cards.length === this.fight.player.nb_slots) {
				if (this.editing) {
					this.toggle_deck()
					setTimeout(() => {
						this.$store.dispatch('start_fight')
					}, 250)
				} else
					this.$store.dispatch('start_fight')
			}
		},
		close_tuto() {
			this.$store.dispatch('edit_config', { tuto: false })
		},
		show_settings() {
			Sounds.play('button')
			this.$store.commit('EDIT_APP_STATE', { settings: true })
		}
	},
	created() {
		this.$store.dispatch('init_game')
	},
	components: { Side, Deck, NextOpponent, Rewards, Tuto, Settings }
}
</script>

<style lang="stylus" scoped>
@import '../assets/css/variables'

.game
	height 100%
	transition transform 0.25s easeOutQuart
	flex center center
	flex-direction column
	&.editing
		transform translateY(-136px)
	&.shake
		animation shake 0.15s linear
		.shake-color
			content ''
			absolute 0
			opacity 0
			z-index 10
			animation opacity 0.05s linear forwards
			&.red
				background-color alpha(red, 4%)
			&.yellow
				background-color alpha(orange_light, 2%)
	.game-button
		position absolute
		left calc(50% - 100px)
		height 64px
		width 200px
		top calc(50% - 32px)
		background-color light
		color dark
		font-size 3.2rem
		font-weight 700
		text-align center
		text-transform uppercase
		line-height (@height + 5px)
		cursor pointer
		transition 0.25s easeOutQuart
		box-shadow 0 0 0 6px dark
		animation button-ready 0.25s easeOutBack
		&.inactive
			background-color desaturate(darken(light, 50%), 90%)
			color lighten(dark, 15%)
			cursor not-allowed
			box-shadow 0 0 0 4px dark
			animation none
			&:hover
				background-color @background-color
			&:active
				background-color @background-color
				transform none
			&:before, &:after
				opacity 0
			&:active
				transform none
		&:before, &:after
			content ''
			position absolute
			width 2px
			height 100%
			background-color light
		&:before
			left -8px
		&:after
			right -8px
		&:hover
			background-color darken(light, 10%)
		&:active
			background-color darken(light, 10%)
			transition 0.1s easeOutQuart
			transform translateY(4px)
	.game-infos
		position absolute
		left 50%
		transform translateX(-50%)
		top 16px
		color light
		letter-spacing 1px
		// background-color light
		font-size 2rem
		text-transform uppercase
	.cog
		position absolute
		left 8px
		top 8px
		padding 8px
		width 48px
		height 48px
		background url('../assets/img/cog.svg') center center no-repeat
		background-size 32px
		cursor pointer
	.score
		position absolute
		right 24px
		top 16px
		flex center center
		flex-direction column
		.label
			width 100%
			margin 0 0 12px 0
			text-transform uppercase
			font-size 2rem
			text-align center
			letter-spacing 1px
		.no
			height 48px
			width 48px
			line-height (@height + 4px)
			color dark
			text-align center
			&:before
				content ''
				absolute 0
				background-color light
				transform rotate(45deg)


@keyframes shake
	0%, 100%
		transform translate(0, 0)
	25%
		transform translate(-2px, 1px)
	50%
		transform translate(2px, -1px)
	75%
		transform translate(1px, 0px)

@keyframes opacity
	0%
		opacity 0
	100%
		opacity 1

@keyframes button-ready
	0%, 100%
		transform none
	50%
		transform scale(1.1)

</style>
